<p>input-with-clipboard works!</p>
